<template>
    <div class="connecting">
        <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M44 2.33398V19.0007"
                stroke="black"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M44 69V85.6667" stroke="black" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M14.541 14.541L26.3327 26.3327"
                stroke="black"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M61.666 61.666L73.4577 73.4577"
                stroke="black"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M2.33398 44H19.0007"
                stroke="black"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M69 44H85.6667" stroke="black" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M14.541 73.4577L26.3327 61.666"
                stroke="black"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M61.666 26.3327L73.4577 14.541"
                stroke="black"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    </div>
</template>

<style scoped lang="scss">
.connecting {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    width: 100%;

    svg {
        width: 88px;
        height: 88px;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    svg {
        animation: spin 3s linear infinite;
    }
}
</style>
